
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    checkboxid: {
      type: String,
      default: '',
    },
  },
});
